import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Paper } from "@material-ui/core";

function getModalStyle() {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 450,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    borderRadius: "3px",
    boxShadow:
      "0px 24px 18px rgba(23, 43, 77, 0.04), 0px 35px 24px rgba(23, 43, 77, 0.08)",
    outline: "none",
    [theme.breakpoints.only("xs")]: {
      width: "90%",
    },
  },
  reSend: {
    cursor: "pointer",
    float: "right",
  },
  Heading: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.KenColors.neutral100,
    textAlign: "left",
    textTransform: "uppercase",
    marginBottom: 24,
  },
}));

export default function Popup(props) {
  const classes = useStyles();
  const { handleClose, open } = props;

  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Paper style={modalStyle} className={classes.paper} elevation={0}>
          {props.children}
        </Paper>
      </Modal>
    </div>
  );
}
